// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {translate} from 'react-i18next';
import i18n from 'i18next';

import {navigateToSearchPage} from 'src/app-lib/helpers/navigation-helper';

import {SearchIcon} from 'src/components/SharedComponents/icons/search-icon';

// Actions
import * as searchActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/search';

export class SearchInput extends React.Component {
    constructor(props) {
        super(props);
        this.textInputField = null;
        this.state = {
            textInputValue: this.props.textInputValue
        };
    }

    componentWillReceiveProps(nextProps) {
        const inputValue = nextProps.textInputValue || '';
        this.setState({textInputValue: inputValue});
    }

    componentDidUpdate() {
        if (!this.textInputField) {
            return;
        }
        if (!this.props.focusOnTextInput) {
            return;
        }
        this.textInputField.focus();
    }

    componentWillUnmount() {
        if (!this.textInputField) {
            return;
        }
        this.textInputField.value = '';
        if (!this.props.focusOnTextInput) {
            return;
        }
        this.textInputField.blur();
    }

    searchHandlers() {
        if (!this.state.textInputValue || this.state.textInputValue.trim().length === 0) {
            return;
        }
        if (this.props.searchEventHandlers) {
            this.props.searchEventHandlers.forEach(handler => {
                handler();
            });
        }
        if (this.textInputField) {
            this.textInputField.blur();
        }
        this.props.getSearchResults(this.state.textInputValue);
        navigateToSearchPage(this.state.textInputValue);
    }

    onKeyDownListener(event) {
        const keyCode = event && event.keyCode;
        if (keyCode === 13) {
            event.preventDefault();
            this.searchHandlers();
        }
    }

    handleInputChange(event) {
        this.setState({textInputValue: event.target.value});
    }

    render() {
        const searchIconProps = {
            onClickHandler: this.searchHandlers.bind(this),
            color: this.props.color,
            iconClassNames: this.props.searchIconClassNames
        };
        const defaultColor = '#ffffff';
        const inputStyle = {
            caretColor: this.props.color || defaultColor,
            color: this.props.color || defaultColor
        };
        const textInputClassNames = this.props.textInputClassNames || 'search-query-input-default';
        const searchInputClassNames = this.props.searchInputClassNames || '';
        const searchPlaceholderClassNames = this.props.color === 'black' ? 'search-placeholder' : '';
        return (
            <div className={`search-input ${searchInputClassNames} ${searchPlaceholderClassNames}`}>
                <form action="" className="search-input-form" onSubmit={() => { return false; }}>
                    <input
                      ref={(input) => {
                          if (input) {
                              this.textInputField = input;
                          }
                      }}
                      className={`search-query-input ${textInputClassNames}`}
                      type="search"
                      style={inputStyle}
                      placeholder={i18n.t('search.placeholder')}
                      maxLength="256"
                      onKeyDown={this.onKeyDownListener.bind(this)}
                      value={this.state.textInputValue}
                      onChange={this.handleInputChange.bind(this)}
                    />
                </form>
                <SearchIcon {...searchIconProps} />
            </div>
        );
    }
}

SearchInput.propTypes = {
    color: PropTypes.string,
    textInputValue: PropTypes.string,
    textInputClassNames: PropTypes.string,
    searchInputClassNames: PropTypes.string,
    searchEventHandlers: PropTypes.array,
    searchIconClassNames: PropTypes.string,
    focusOnTextInput: PropTypes.bool,
    getSearchResults: PropTypes.func.isRequired
};
export default connect(
    null,
    dispatch => bindActionCreators(Object.assign({}, searchActions), dispatch)
)(translate(['translation'])(SearchInput));



// WEBPACK FOOTER //
// ./src/components/search/search-input.js